import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpService {
  getDataFlight: any;
  getData: any;
  baseUrlFlight = environment.flightConfig.apiUrl;  // Flight API url
  // baseUrlFlight___ = environment.flightConfig.apiUrl__;  // Flight API url
  baseUrlHotel = environment.hotelConfig.apiUrl; // this is used nfor API
  baseUrlVISA = environment.vISAConfig.apiUrl; //
  // host = environment.config.apiUrl;

  // encryptSecretKey = 'hbaerfewrifqrqrefYQGRyuqeurQRqRF&#*$R#&$YR*@Y$&#$*YUERVEAvfu';
  loading = false;
  awaitData = false;

  constructor(private http: HttpClient,) { }

  // <<<<<<<<<<<<<<<<------------------ Flight API HTTP REQUESTS------------------------>>>>>>>>>>>>>>>>>
  flightget(endpoint: string, params = {}) {
    return this.http.get<any>(this.baseUrlFlight + endpoint, { params });
  }

  flightpost(endpoint: string, params = {}) {
    return this.http.post<any>(this.baseUrlFlight + endpoint, { params });
  }

  flightgetall(endpoint: string) {
    return this.http.get<any>(this.baseUrlFlight + endpoint);
  }

  flightsave(endpoint: string, data: any) {
    return this.http.post<any>(this.baseUrlFlight + endpoint, data);
  }
  
  flightsaveGET_METHOD(endpoint: string, params: any) {
    return this.http.get<any>(this.baseUrlFlight + endpoint, { params });
  }

  flightdelete(endpoint: string, id: string) {
    return this.http.delete<any>(this.baseUrlFlight + endpoint + id);
  }

  flightDelete(endpoint: string, data: any) {
    return this.http.delete<any>(this.baseUrlFlight + endpoint, data);
  }

  flightupdate(endpoint, id, data) {
    return this.http.put<any>(this.baseUrlFlight + endpoint + id, data);
  }  
  
  flightUPDATE(endpoint, data) {
    return this.http.put<any>(this.baseUrlFlight + endpoint, data);
  }

  // flightsave___(endpoint: string, data: any) {
  //   return this.http.post<any>(this.baseUrlFlight___ + endpoint, data);
  // }


  // <<<<<<<<<<<<<<<<<-------------------- Hotel API HTTP REQUESTS---------------------->>>>>>>>>>>>>>>>>>>>>>>

  hotelget(endpoint: string, params = {}) {
    return this.http.get<any>(this.baseUrlHotel + endpoint, { params });
  }

  hotelgetData(endpoint: string, data) {
    return this.http.post<any>(this.baseUrlHotel + endpoint, data);
  }

  // hotelgetData(endpoint: string, params = {}){
  //   return this.http.get<any>(this.baseUrlHotel + endpoint, { params });
  // }

  hotelPost(endpoint: string, params = {}) {
    return this.http.post<any>(this.baseUrlHotel + endpoint, { params });
  }

  hotelgetAll(endpoint: string) {
    return this.http.get<any>(this.baseUrlHotel + endpoint);
  }

  hotelsave(endpoint: string, data: any) {
    return this.http.post<any>(this.baseUrlHotel + endpoint, data);
  }

  hoteldelete(endpoint: string, id: string) {
    return this.http.delete<any>(this.baseUrlHotel + endpoint + id);
  }

  hotelupdate(endpoint, id, data) {
    return this.http.put<any>(this.baseUrlHotel + endpoint + id, data);
  }

  hotelgetCities(val) {
    return this.getData(`city/`, val);
  }

  // <<<<<<<<<<<<<<<<------------------ Country HTTP REQUESTS------------------------>>>>>>>>>>>>>>>>>
  getCountryList() {
    return this.http.get(`${this.baseUrlFlight}apiV2/country/index`)
  }

  getCountryStates(countryId: string) {
    return this.http.post(`${this.baseUrlFlight}apiV2/country/state`, { country_id: countryId })
  }

  getCountryCity(stateId: string) {
    return this.http.post(`${this.baseUrlFlight}apiV2/country/city`, { state_id: stateId })
  }

  // <<<<<<<<<<<<<<<<------------------ VISA API HTTP REQUESTS------------------------>>>>>>>>>>>>>>>>>

  VISA_get(endpoint: string) {
    return this.http.get<any>(this.baseUrlVISA + endpoint);
  }

  VISA_save(endpoint: string, data: any) {
    return this.http.post<any>(this.baseUrlVISA + endpoint, data);
  }
}
